import React, { useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { RxCross1 } from "react-icons/rx";
import { SuccessPopUp } from "../../../CommonComponents/SuccessPopUp";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

function UpdateDisplayCate() {
    let navigate = useNavigate();

    const BASE_URL = process.env.REACT_APP_PP_URL;
    const getToken = sessionStorage.getItem('tokenKey');

    // GET UPDATE DATA
    const location = useLocation();

    const product = location && location.state;

    const [categoryName, setCategoryName] = useState(product.title);
    const [description, setDescription] = useState(product.description);

    const convertToPlainText = (html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        return doc.body.textContent || "";
    };
    const descriptions = convertToPlainText(description)
    const cateValues = {
        title: categoryName,
        description: descriptions,
    };

    // UPDATE ITEM
    const postUpdateItem = async (id) => {
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/display-category/update/${id}`, {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${getToken}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(cateValues)
            });

            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                setShow(true);
                setAction('Category Updated Successfully');
                setNavv('ok');
            } else {
                setShow(true);
                setAction('something went wrong!');
                setNavv('ok');
            }
        } catch (e) {
            console.log(e, 'error in updating api');
        };
    };

    // HANDLE POPUP
    const [show, setShow] = useState(false);
    const [action, setAction] = useState();
    const [navv, setNavv] = useState();
    const navToCat = useNavigate();

    const handleOk = () => {
        navToCat('/admin/displayCat');
    };

    const [errors, setErrors] = useState({});
    const titleRef = useRef(null);
    const handleValidation = () => {
        let newErrors = {};
        if (!categoryName?.trim()) newErrors.title = "Title is required.";
        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) {
            const firstErrorField = Object.keys(newErrors)[0];
            scrollToField(firstErrorField);
            return false;
        };
        return true;
    };

    const scrollToField = (field) => {
        switch (field) {
            case "title":
                titleRef.current?.scrollIntoView({ top: 0, behavior: "smooth" });
                break;
            default:
                break;
        }
    };

    const handleSubmit = () => {
        handleValidation();
        if (handleValidation()) {
            postUpdateItem(product.uuid);
        }
    };

    return (
        <>
            <div className="add-item">
                <div className="row">
                    <div className="category-nav">
                        <div className="category-text">
                            <h4>Update Display-Category</h4>
                        </div>
                        <div className="category-btn" style={{ width: "60%" }}>
                            <button onClick={() => navigate(-1)}><RxCross1 /></button>
                        </div>
                    </div>
                    <hr />

                    <div className="main-container">
                        <div className="add-form" ref={titleRef}>
                            {/* Title Input */}
                            <div className="add w-100 m-b2">
                                <label style={errors.title && { color: "red" }}>Title</label>
                                <input
                                    type="text"
                                    name="title"
                                    onChange={(e) => { e.preventDefault(); setCategoryName(e.target.value) }}
                                    value={categoryName}
                                // placeholder="Tittle"
                                />
                            </div>

                            <div className="editer m-b2">
                                {/* Jodit Editor */}
                                <div className="add w-100">
                                    <label>Description</label>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        config={{
                                            toolbar: {
                                                items: [
                                                    "heading",
                                                    "|",
                                                    "bold",
                                                    "italic",
                                                    "link",
                                                    "bulletedList",
                                                    "numberedList",
                                                    "|",
                                                    "indent",
                                                    "outdent",
                                                    "|",
                                                    "imageUpload",
                                                    "blockQuote",
                                                    "mediaEmbed",
                                                    "undo",
                                                    "redo",
                                                ],
                                            },
                                        }}
                                        data={description}
                                        onChange={(event, editor) => {
                                            const data = editor.getData();
                                            setDescription(data);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="btn submit-btn">
                        <button onClick={() => handleSubmit()}>Submit</button>
                    </div>
                </div>
            </div>

            <SuccessPopUp
                isOpen={show}
                navv={navv}
                action={action}
                onConfirm={handleOk}
                onClose={handleOk}
            />
        </>
    );
}

export default UpdateDisplayCate;

